import { Component } from '@verndale/core';
import { Debounce } from '../utils';

class AlertBanner extends Component {
  private cookieName: string = 'alertBannerClosed';
  private alertId: string = '';
  private variableName: string = '--alert-banner-height';
  private checkBannerHeight: boolean = false;

  constructor(el: HTMLElement) {
    super(el);
    this.alertId = el.getAttribute('data-alert-id') || '';
    this.el.style.display = 'none';
    this.checkBannerVisibility();
  }

  setBannerCssVariables() {
    if (!this.checkBannerHeight) return;

    const { el } = this;
    const height = el.offsetHeight;

    document.body.style.setProperty(this.variableName, `${height}px`);
  }

  removeBannerCssVariables() {
    if (!this.checkBannerHeight) return;

    document.body.style.removeProperty(this.variableName);
    this.checkBannerHeight = false;
  }

  setupDefaults() {
    this.dom = {
      closeButton: this.el.querySelector<HTMLElement>('.alert-banner__close'),
      banner: this.el
    };

    const isDarkTheme = this.el.classList.contains('alert-banner--dark');
    if (!isDarkTheme) {
      this.el.classList.add('alert-banner--light');
    }
  }

  addListeners() {
    if (this.dom.closeButton && !(this.dom.closeButton instanceof NodeList)) {
      this.dom.closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    window.addEventListener('resize', () => {
      if (this.checkBannerHeight) {
        Debounce(this.setBannerCssVariables.bind(this), 100)();
      }
    });
  }

  handleClose() {
    this.hideBanner();
    this.setCookie(`${this.cookieName}-${this.alertId}`, 'true', 365);
  }

  checkBannerVisibility() {
    const wasClosed = this.getCookie(`${this.cookieName}-${this.alertId}`);
    if (wasClosed !== 'true') {
      this.showBanner();
    }
  }

  showBanner() {
    if (this.dom && this.dom.banner && !(this.dom.banner instanceof NodeList)) {
      this.dom.banner.style.display = 'block';
    } else if (this.el) {
      this.el.style.display = 'block';
    }
    this.checkBannerHeight = true;
    this.setBannerCssVariables();
  }

  hideBanner() {
    if (this.dom && this.dom.banner && !(this.dom.banner instanceof NodeList)) {
      this.dom.banner.style.display = 'none';
    } else if (this.el) {
      this.el.style.display = 'none';
    }
    this.checkBannerHeight = true;
    this.removeBannerCssVariables();
  }

  setCookie(name: string, value: string, days: number) {
    try {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
    } catch (e) {
      console.error('Error setting cookie:', e);
    }
  }

  getCookie(name: string): string {
    try {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return '';
    } catch (e) {
      console.error('Error getting cookie:', e);
      return '';
    }
  }
}

export default AlertBanner;
